import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  arrayPush,
  change,
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  reduxForm,
} from "redux-form"
import validate from "./listMenuItemValidation"
import renderListItemForm from "./listItemForm"
import {
  addNewList,
  getListFeature,
  hideCopyListModal,
  hideListItemPopup,
  openCopyListModal,
  openListItemPopup,
  resetListFeature,
  updateList,
} from "store/actions"
import {
  mapApiResponseToListForm,
  mapListItemsToApi,
  mapUpdatedListItemsToApi,
} from "../utils"
import ModalComponent from "components/Modals"
import CopyListModal from "./copyListModal"
import PropTypes from "prop-types"
import ListPreview from "./listPreview"
import PopUpPreview from "./popUpPreview"
import { LoadingIndicator } from "components/LoadingIndicator"

let ListMenuItem = props => {
  const [previewToggle, setPreviewToggle] = useState(true)
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false)
  const [publishProps, setPublishProps] = useState(null)

  useEffect(() => {
    if (props.feature.entity_id) {
      props.getListFeature(props.feature.entity_id)
    }
    return () => {
      props.resetListFeature()
    }
  }, [])

  useEffect(() => {
    if (props.listFeature) {
      props.change(
        "list_form.listItems",
        mapApiResponseToListForm(props.listFeature.list_items)
      )
      if (props.listFeature.menu_feature === 0) {
        props.change("list_form.name", props.listFeature.name)
      }
    }
  }, [props.listFeature])

  const submitListHandler = data => {
    if (!props.listFeature) {
      const listItems = mapListItemsToApi(
        data.list_form.listItems,
        props.vendorId
      )
      const listFeature = {
        business_unit_id: props?.selectedEvent?.business_unit_id,
        event_id: props?.selectedEvent?.id,
        menu_feature: 1,
        menu_item_id: props.feature.id,
        name: props.feature.label,
        order: 0,
        status: props.feature.status ? 1 : 0,
        user_id: props.userId,
        vendor_id: props.vendorId,
      }
      props.addNewList({ listItems: listItems, listFeature: listFeature })
    } else {
      const listItems = data.list_form.listItems.map((item, index) => ({
        ...item,
        order: index,
      }))
      const newListItems = mapListItemsToApi(
        listItems.filter(item => !item?.id),
        props.vendorId
      )
      const updatedListItems = mapUpdatedListItemsToApi(
        listItems.filter(item => item?.id),
        props.vendorId
      )
      const listFeature = {
        event_id: props?.selectedEvent?.id,
        menu_feature: 1,
        menu_item_id: props.feature.id,
        name: props.feature.label,
        order: 0,
        send_notification: false,
        status: props.feature.status ? 1 : 0,
        user_id: props.userId,
        vendor_id: props.vendorId,
        id: props.feature.entity_id,
      }
      const propsData = {
        newListItems: newListItems,
        updatedListItems: updatedListItems,
        listFeature: listFeature,
      }
      if (newListItems && newListItems?.length > 0 && !!props.feature.status) {
        setPublishProps(propsData)
        setNotificationModalIsOpen(true)
      } else {
        props.updateList(propsData)
      }
    }
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
              <Col xs="auto">
                <SaveButton
                  content="Copy List"
                  type="button"
                  onClick={props.openCopyListModal}
                />
              </Col>
              {props.isListItem && (
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Cancel"
                    color="light"
                    onClick={props.backButtonHandler}
                  />
                </Col>
              )}
              <Col xs="auto">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={
                    props.isListItem
                      ? props.handleSubmit(props.handleAddListItem)
                      : props.handleSubmit(submitListHandler)
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {props.isListItem && (
                  <Card className="mt-4">
                    <CardHeader>
                      <h4>CREATE A NAME FOR YOUR LIST</h4>
                    </CardHeader>
                    <CardBody>
                      <Row className="mb-2">
                        <Col>
                          <Field
                            name="name"
                            component={TextField}
                            label="Name"
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                )}
                <Card>
                  <CardHeader>
                    <h4>ADD LIST ITEMS</h4>
                  </CardHeader>
                  <CardBody>
                    <Row className="my-3">
                      <Col xs={12}>
                        Drag & drop{" "}
                        <i className="bx bx-sm bx-menu align-middle" /> to
                        reorder list items, then click on "Save".
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col xs={12}>
                        <FieldArray
                          name="listItems"
                          component={renderListItemForm}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h5
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            props.addListItem(
                              FORM_NAMES.LIST,
                              "list_form.listItems",
                              {
                                backgroundColor: "#FFFFFF",
                                textColor: "#000000",
                              }
                            )
                          }
                        >
                          + Add Another List Item
                        </h5>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row className="my-2">
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      type="button"
                      content="Save"
                      onClick={
                        props.isListItem
                          ? props.handleSubmit(props.handleAddListItem)
                          : props.handleSubmit(submitListHandler)
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <Row>
                  <p style={{ textAlign: "center", margin: "0px" }}>
                    <b>
                      {previewToggle
                        ? "List Preview"
                        : "List Item Pop Up Preview"}
                    </b>
                  </p>
                </Row>
                <Row xs="auto" className="d-flex justify-content-center my-2">
                  <SaveButton
                    type="button"
                    content="Toggle Screens"
                    onClick={() => setPreviewToggle(!previewToggle)}
                  />
                </Row>
                {previewToggle ? (
                  <ListPreview
                    menu_bg_color={props.design?.menu_bg_color}
                    menu_font_color={props.design?.menu_font_color}
                    bgImage={props.design?.bg_image_url}
                    title={props?.formValues?.name || props?.feature?.label}
                    listItems={props.formValues?.listItems}
                  />
                ) : (
                  <PopUpPreview listItems={props.formValues?.listItems} />
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title="Copy List Content from: "
        open={props.isCopyListModalOpen}
        onClose={props.hideCopyListModal}
        size="lg"
      >
        <CopyListModal
          closeHandler={props.hideCopyListModal}
          listFeature={
            props.listFeature || {
              business_unit_id: props?.selectedEvent?.business_unit_id,
              event_id: props?.selectedEvent?.id,
              list_items: [],
              menu_feature: props.isListItem ? 0 : 1,
              menu_item_id: props.feature.id,
              name: props.isListItem ? null : props.feature.label,
              order: 0,
              status: props.feature.status ? 1 : 0,
              user_id: props.userId,
              vendor_id: props.vendorId,
            }
          }
          isListItem={props.isListItem}
          backButtonHandler={props.backButtonHandler}
        />
      </ModalComponent>
      <ModalComponent
        open={notificationModalIsOpen}
        onClose={() => setNotificationModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that a new list
            item has been added to this list?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (publishProps) {
                  props.updateList(publishProps)
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (publishProps) {
                  props.updateList({
                    ...publishProps,
                    listFeature: {
                      ...publishProps?.listFeature,
                      send_list_item_notification: true,
                    },
                  })
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </FormSection>
  )
}

ListMenuItem = reduxForm({
  form: FORM_NAMES.LIST,
  initialValues: {
    list_form: {
      listItems: [{ backgroundColor: "#FFFFFF", textColor: "#000000" }],
    },
  },
  validate,
})(ListMenuItem)

const selector = formValueSelector(FORM_NAMES.LIST)

const mapStateToProps = state => ({
  isListItemPopupOpen: state.List.isListItemPopupOpen,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  isCopyListModalOpen: state.List.isCopyListModalOpen,
  listFeature: state.List.listFeature,
  loading: state.List.loading,
  formValues: selector(state, "list_form"),
})

const mapDispatchToProps = dispatch => ({
  addListItem: (form, field, values) =>
    dispatch(arrayPush(form, field, values)),
  openListItemPopup: () => dispatch(openListItemPopup()),
  hideListItemPopup: () => dispatch(hideListItemPopup()),
  addNewList: values => dispatch(addNewList(values)),
  openCopyListModal: () => dispatch(openCopyListModal()),
  hideCopyListModal: () => dispatch(hideCopyListModal()),
  getListFeature: values => dispatch(getListFeature(values)),
  resetListFeature: () => dispatch(resetListFeature()),
  change: (field, value) => dispatch(change(field, value)),
  updateList: values => dispatch(updateList(values)),
})

ListMenuItem.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListMenuItem)
